import { asEmptySvg, asThemedSvg } from "../../hocs";
import SenseRowBoxSvg from "./SenseRowBoxSvg";
import SenseRowMinimalSvg from "./SenseRowMinimalSvg";
import SenseRowSmallBoxSvg from "./SenseRowSmallBoxSvg";

const EmptySenseRowBoxSvg = asEmptySvg(SenseRowBoxSvg);
const ThemedSenseRowBoxSvg = asThemedSvg(SenseRowBoxSvg);
const EmptySenseRowSmallBoxSvg = asEmptySvg(SenseRowSmallBoxSvg);
const ThemedSenseRowSmallBoxSvg = asThemedSvg(SenseRowSmallBoxSvg);
const EmptySenseRowMinimalSvg = asEmptySvg(SenseRowMinimalSvg);
const ThemedSenseRowMinimalSvg = asThemedSvg(SenseRowMinimalSvg);

export default SenseRowBoxSvg;
export {
  SenseRowBoxSvg,
  SenseRowSmallBoxSvg,
  EmptySenseRowBoxSvg,
  ThemedSenseRowBoxSvg,
  EmptySenseRowSmallBoxSvg,
  ThemedSenseRowSmallBoxSvg,
  SenseRowMinimalSvg,
  EmptySenseRowMinimalSvg,
  ThemedSenseRowMinimalSvg,
};
